import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    actions: {
        defaultMessage: 'Action(s)',
        id: 'iaso.label.actions',
    },
    cancel: {
        id: 'iaso.label.cancel',
        defaultMessage: 'Cancel',
    },
    created_at: {
        id: 'iaso.label.created_at',
        defaultMessage: 'Created',
    },
    created_by: {
        id: 'iaso.label.created_by',
        defaultMessage: 'Created by',
    },
    creation: {
        id: 'iaso.label.creation',
        defaultMessage: 'Creation',
    },
    confirm: {
        id: 'iaso.label.confirm',
        defaultMessage: 'Confirm',
    },
    confirmSuppression: {
        id: 'iaso.orgUnitChangeRequestConfigs.title.confirmSuppression',
        defaultMessage: 'Delete configuration for {project} - {orgUnitType}?',
    },
    delete: {
        defaultMessage: 'Delete',
        id: 'iaso.label.delete',
    },
    deleteCannotBeUndone: {
        defaultMessage: 'This operation cannot be undone.',
        id: 'iaso.label.deleteText',
    },
    edit: {
        defaultMessage: 'Edit',
        id: 'iaso.label.edit',
    },
    editable_fields: {
        defaultMessage: 'Editable Fields',
        id: 'iaso.label.editableFields',
    },
    edition: {
        id: 'iaso.label.edition',
        defaultMessage: 'Edition',
    },
    orgUnitChangeRequestConfigurations: {
        id: 'iaso.label.orgUnitChangeRequestConfigurations',
        defaultMessage: 'Change Requests Configuration',
    },
    orgUnitType: {
        id: 'iaso.label.orgUnitsType',
        defaultMessage: 'Org unit type',
    },
    project: {
        id: 'iaso.label.project',
        defaultMessage: 'Project',
    },
    type: {
        id: 'iaso.label.type',
        defaultMessage: 'Type',
    },
    updated_at: {
        id: 'iaso.forms.updated_at',
        defaultMessage: 'Updated',
    },
    updated_by: {
        id: 'iaso.label.updated_by',
        defaultMessage: 'Updated by',
    },
    close: {
        id: 'iaso.label.close',
        defaultMessage: 'Close',
    },
    next: {
        id: 'iaso.label.next',
        defaultMessage: 'Next',
    },
    oucrcCreateModalTitle: {
        id: 'iaso.oucrc.oucrcCreateModalTitle',
        defaultMessage: 'OrgUnit Change Request Configuration - Creation',
    },
    oucrcCreateSecondStepModalTitle: {
        id: 'iaso.oucrc.oucrcCreateModalTitle2',
        defaultMessage:
            'OrgUnit Change Request Configuration - Creation 2nd step',
    },
    oucrcCreateUpdateModalTitle: {
        id: 'iaso.oucrc.oucrcCreateUpdateModalTitle',
        defaultMessage: 'OrgUnit Change Request Configuration - Update',
    },
    requiredField: {
        id: 'iaso.forms.error.fieldRequired',
        defaultMessage: 'This field is required',
    },
    orgUnitsEditable: {
        id: 'iaso.oucrc.orgUnitsEditable',
        defaultMessage: 'Should OrgUnits of this type be editable?',
    },
    orgUnitsEditableYes: {
        id: 'iaso.forms.yes',
        defaultMessage: 'Yes',
    },
    orgUnitsEditableNo: {
        id: 'iaso.forms.no',
        defaultMessage: 'No',
    },
    name: {
        id: 'iaso.label.name',
        defaultMessage: 'Name',
    },
    aliases: {
        id: 'iaso.forms.aliases',
        defaultMessage: 'Aliases',
    },
    openingDate: {
        id: 'iaso.changeRequest.openingDate',
        defaultMessage: 'Opening Date',
    },
    closedDate: {
        id: 'iaso.oucrc.closedDate',
        defaultMessage: 'Closing Date',
    },
    location: {
        id: 'iaso.label.location',
        defaultMessage: 'Location',
    },
    editableFields: {
        id: 'iaso.label.editableFields',
        defaultMessage: 'Editable Fields',
    },
    possibleTypeIds: {
        id: 'iaso.oucrc.possibleTypeIds',
        defaultMessage: 'Possible New Types',
    },
    possibleParentTypeIds: {
        id: 'iaso.oucrc.possibleParentTypeIds',
        defaultMessage: 'Parent',
    },
    groupSetIds: {
        id: 'iaso.oucrc.groupSetIds',
        defaultMessage: 'Group Sets',
    },
    editableReferenceFormIds: {
        id: 'iaso.oucrc.editableReferenceFormIds',
        defaultMessage: 'Editable Reference Forms',
    },
    otherGroupIds: {
        id: 'iaso.oucrc.otherGroupIds',
        defaultMessage: 'Other Groups',
    },
    oucrcModalCreateButton: {
        id: 'iaso.label.create',
        defaultMessage: 'Create',
    },
    oucrcModalUpdateButton: {
        id: 'iaso.mappings.label.update',
        defaultMessage: 'Update',
    },
    warningMessageOrgUnitChangeConfig: {
        id: 'iaso.orgUnitChangeRequestConfigs.warningMessageOrgUnitChangeConfig',
        defaultMessage:
            'Org Unit Types which do not have a configuration can be edited by the users without restriction.',
    },
});

export default MESSAGES;
